import { ROUTES } from '@aibees/elephant/router';
import { DialogTitle } from '@aibees/shared/components';
import { useBoolean } from '@aibees/shared/hooks';
import { usePaymentStatus } from '@aibees/shared/hooks/payment/use-payment-status';
import { classnames } from '@aibees/shared/utils';
import { Button, DialogActions, DialogContent, Stack } from '@mui/material';
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { PaymentFailedRestrictionDialogContent } from './components/payment-failed-restriction-dialog-content';
import * as Styled from './styles';
import * as SX from './sx';
import type { PaymentFailedRestrictionDialogProps as Props } from './types';

export const PaymentFailedRestrictionDialog = memo(({ className }: Props) => {
  const state = useBoolean(true);
  const navigate = useNavigate();
  const { paymentFailed } = usePaymentStatus();

  if (!paymentFailed) return null;

  const handleGoToBilling = () => {
    state.onFalse();
    navigate(ROUTES.billing);
  };

  const handleClose = () => {
    state.onFalse();
  };

  return (
    <Styled.Wrapper
      className={classnames('PaymentFailedRestrictionDialog', className)}
      open={state.value}
      sx={SX.root}
      fullWidth={true}
      maxWidth="xs"
    >
      <DialogTitle
        title="Payment Required"
        icon="credit-card-outlined"
        onClose={handleClose}
      />
      <DialogContent>
        <PaymentFailedRestrictionDialogContent />
      </DialogContent>

      <DialogActions>
        <Stack direction="row" justifyContent="space-between" width="100%">
          <Button
            variant="outlined"
            color="default"
            size="small"
            onClick={handleClose}
          >
            Close
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleGoToBilling}
          >
            Go to Billing
          </Button>
        </Stack>
      </DialogActions>
    </Styled.Wrapper>
  );
});

PaymentFailedRestrictionDialog.displayName = 'PaymentFailedRestrictionDialog';
